import { render } from "./BackgroundMusic.vue?vue&type=template&id=619f035a&scoped=true"
import script from "./BackgroundMusic.vue?vue&type=script&lang=js"
export * from "./BackgroundMusic.vue?vue&type=script&lang=js"

import "./BackgroundMusic.vue?vue&type=style&index=0&id=619f035a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619f035a"]])

export default __exports__